import styles from "./styles.module.scss";
import Footer from "../../components/Footer"
import Header from "../../components/Header"
import Contact from "../../components/HomePage/Contact"
import Intro from "../../components/HomePage/Intro";

import React, { useRef } from 'react'

import Services from "../../components/HomePage/Services";
import Value from "../../components/HomePage/Value";
import Processus from "../../components/HomePage/Processus";
import ProcessusPhone from "../../components/HomePage/ProcessusForPhone";

function WebDev() {
  const intro = useRef(null)
  const services = useRef(null)
  const processus = useRef(null)
  const processusPhone = useRef(null)
  const value = useRef(null)
  const contact = useRef(null)

  return (
    <>
      <section className={styles.Container}>
        <div className={styles.navBar}>
          <Header intro={intro} services={services} processus={processus} value={value} contact={contact} processusPhone={processusPhone}/>
        </div>
       
        <div className={styles.intro} ref={intro}>
          <Intro />
        </div>
        <div className={styles.services} ref={services}>
          <Services />
        </div>
        <div className={styles.processus} ref={processus}>
          <Processus />
        </div>
        <div className={styles.values} ref={value}>
          <Value />
        </div>
        <div className={styles.processusPhone} ref={processusPhone}>
          <ProcessusPhone />
        </div>
        <div className={styles.contact} ref={contact}>
          <Contact />
        </div>
        <div className={styles.footer}>
          <Footer />
        </div>
        
      </section>
    </>
  );
}

export default WebDev;